<template>
  <div id="app" :class="appClass">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    appClass() {
      const path = this.$route && this.$route.path ? this.$route.path : ''
      return path === '/login' ? 'app-auth' : 'app-admin'
    }
  }
}
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

#app {
  width: 100%;
  min-height: 100vh;
}

.app-admin {
  background:
    linear-gradient(180deg, rgba(59, 130, 246, 0.08), rgba(255, 255, 255, 0) 240px),
    #f0f4f8;
  color: #10233a;
}

.app-admin .admin-page {
  background: transparent;
  color: #10233a;
}

.app-admin .admin-page .container {
  max-width: 1280px;
  margin: 0 auto;
}

.app-admin .admin-page .header,
.app-admin .admin-page .actions,
.app-admin .admin-page .list-container,
.app-admin .admin-page .form-container,
.app-admin .admin-page .video-section,
.app-admin .admin-page .upload-section,
.app-admin .admin-page .dialog-content,
.app-admin .admin-page .form-card,
.app-admin .admin-page .modal-content,
.app-admin .admin-page .answer-panel,
.app-admin .admin-page .report-card {
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(18px);
  border: 1px solid rgba(59, 130, 246, 0.12);
  box-shadow: 0 16px 40px rgba(16, 35, 58, 0.08);
}

.app-admin .admin-page .header {
  border-radius: 16px;
}

.app-admin .admin-page .btn,
.app-admin .admin-page .action-btn,
.app-admin .admin-page .logout-btn,
.app-admin .admin-page .btn-sm,
.app-admin .admin-page .icon-btn,
.app-admin .admin-page .review-item,
.app-admin .admin-page .menu-card,
.app-admin .admin-page .stat-card,
.app-admin .admin-page .case-item,
.app-admin .admin-page .exam-item,
.app-admin .admin-page .student-item,
.app-admin .admin-page .video-card,
.app-admin .admin-page .summary-card,
.app-admin .admin-page .info-card,
.app-admin .admin-page .analysis-card,
.app-admin .admin-page .standard-card,
.app-admin .admin-page .answer-card {
  border-radius: 12px;
}

.app-admin .admin-page .btn-primary,
.app-admin .admin-page .action-btn.primary {
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  color: #fff;
  border: 0;
}

.app-admin .admin-page .btn-success {
  background: linear-gradient(135deg, #06B6D4 0%, #10B981 100%);
  color: #fff;
  border: 0;
}

.app-admin .admin-page .btn-danger {
  background: linear-gradient(135deg, #f87171, #ef4444);
  color: #fff;
  border: 0;
}

.app-admin .admin-page .btn-outline,
.app-admin .admin-page .logout-btn,
.app-admin .admin-page .action-btn {
  background: rgba(255, 255, 255, 0.86);
  color: #2563eb;
  border: 1px solid rgba(37, 99, 235, 0.18);
}

.app-admin .admin-page .user-info,
.app-admin .admin-page .case-desc,
.app-admin .admin-page .exam-meta,
.app-admin .admin-page .student-meta,
.app-admin .admin-page .video-description,
.app-admin .admin-page .card-note,
.app-admin .admin-page .header-subtitle,
.app-admin .admin-page .subtitle,
.app-admin .admin-page .empty-state,
.app-admin .admin-page .empty-text,
.app-admin .admin-page .review-meta {
  color: #5b6b7d;
}

.app-admin .admin-page .spinner,
.app-admin .admin-page .loading .spinner,
.app-admin .admin-page .loading-container .spinner {
  border-color: rgba(59, 130, 246, 0.18);
  border-top-color: #3B82F6;
}

.app-admin .admin-page input,
.app-admin .admin-page select,
.app-admin .admin-page textarea {
  background: rgba(255, 255, 255, 0.92);
  color: #10233a;
  border: 1px solid rgba(59, 130, 246, 0.14);
}

.app-admin .admin-page input:focus,
.app-admin .admin-page select:focus,
.app-admin .admin-page textarea:focus {
  outline: none;
  border-color: rgba(37, 99, 235, 0.5);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.app-admin .admin-page h1,
.app-admin .admin-page h2,
.app-admin .admin-page h3,
.app-admin .admin-page h4,
.app-admin .admin-page h5 {
  color: #10233a;
}

.app-admin .admin-page .header h1 span {
  background: linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>
